import { CallbackPage as OidcCallbackPage } from '@tagna/auth';

const REDIRECT_PATH_KEY = 'redirectPath';
const LOGIN_REDIRECT_LOCK_KEY = 'admin_login_redirect_lock';

const isSafeRedirectPath = (path: string | null): path is string => {
  return !!path && path.startsWith('/') && !path.startsWith('/auth/');
};

export function CallbackPage() {
  return (
    <OidcCallbackPage
      type="signin"
      onSuccess={() => {
        sessionStorage.removeItem(LOGIN_REDIRECT_LOCK_KEY);

        // Redirect to the original requested page or dashboard
        const redirectPath = sessionStorage.getItem(REDIRECT_PATH_KEY);
        sessionStorage.removeItem(REDIRECT_PATH_KEY);
        window.location.replace(isSafeRedirectPath(redirectPath) ? redirectPath : '/');
      }}
    />
  );
}
